export const it = {
  PRODUCT_INFO_TITLE: 'Informazioni sul Prodotto',
  PRODUCT_INFO_DESCRIPTION: 'Dettagli sul prodotto.',
  DIMENSIONS_LABEL: 'Dimensioni',
  MODEL_NUMBER_LABEL: 'Numero di Modello',
  MATERIAL_TYPE_LABEL: 'Tipo di Materiale',
  GLASS_TYPE_LABEL: 'Tipo di Vetro',
  ENERGY_RATING_LABEL: 'Classe Energetica',
  MANUFACTURING_DATE_LABEL: 'Data di Produzione',
  SERIAL_NUMBER_LABEL: 'Numero di Serie',
  INSTALLATION_STATUS_LABEL: "Stato dell'Installazione",
  WINDOW_TYPE_LABEL: 'Tipo di Finestra',

  INSTALLATION_PROCESS_TITLE: 'Processo di Installazione',
  INSTALLATION_PROCESS_DESCRIPTION: 'Dettagli sul processo di installazione.',
  SCHEDULED_DATE_LABEL: 'Data Programmata',
  INSTALLER_LABEL: 'Installatore',
  DURATION_LABEL: 'Durata',
  STATUS_LABEL: 'Stato',
  TOOLS_REQUIRED_LABEL: 'Strumenti Richiesti',
  INSTALLER_NAME_LABEL: "Nome dell'Installatore",
  TOOLS_NEEDED_LABEL: 'Strumenti Necessari',
  INSTALLATION_NOTES_LABEL: 'Note di Installazione',
  WINDOW_PHOTO_LABEL: 'Foto della Finestra',
  INSTALLATION_PHOTOS_LABEL: "Foto dell'Installazione",

  MAINTENANCE_LOG_TITLE: 'Registro di Manutenzione',
  MAINTENANCE_LOG_DESCRIPTION: 'Dettagli sulle attività di manutenzione.',
  LAST_SERVICE_LABEL: 'Ultimo Servizio',
  SERVICE_TYPE_LABEL: 'Tipo di Servizio',
  TECHNICIAN_LABEL: 'Tecnico',
  NEXT_SERVICE_DUE_LABEL: 'Prossimo Servizio Dovuto',

  START_INSTALLATION_TITLE: "Inizia l'Installazione",
  START_INSTALLATION_DESCRIPTION: "Procedura guidata per l'installazione.",
  INSTALLER_NAME_QUESTION: "Qual è il nome dell'installatore?",
  WINDOW_TYPE_QUESTION: 'Che tipo di finestra viene installata?',
  TOOLS_NEEDED_QUESTION: "Quali strumenti sono necessari per l'installazione?",
  INSTALLATION_NOTES_QUESTION: "Note aggiuntive per l'installazione?",
  WINDOW_PHOTO_QUESTION: 'Carica una foto della finestra.',
  INSTALLATION_PHOTOS_QUESTION: 'Carica foto del processo di installazione.',

  // Installation Wizard Questions
  SCHEDULED_DATE_QUESTION: "Qual è la data programmata per l'installazione?",
  INSTALLER_QUESTION: "Chi è l'installatore assegnato?",
  INSTALLER_DASHBOARD: 'Dashboard Installatore',

  // Installer Dashboard
  INSTALLER_LOADING: 'Caricamento dei tuoi cantieri...',
  INSTALLER_ERROR_TITLE: 'Errore nel Caricamento dei Cantieri',
  INSTALLER_TRY_AGAIN: 'Riprova',
  INSTALLER_PROJECT_INVITATIONS: 'Inviti ai Cantieri',
  INSTALLER_NEW_PROJECT_INVITATION: 'Nuovo Invito al Commessa',
  INSTALLER_PROJECT_DEFAULT: 'Commessa',
  INSTALLER_ACCEPT: 'Accetta',
  INSTALLER_REJECT: 'Rifiuta',
  INSTALLER_RECENT_PROJECTS: 'Commesse in corso di lavorazione',
  INSTALLER_NO_RECENT_PROJECTS: 'Nessun Commessa Recente',
  INSTALLER_PROJECTS_APPEAR_MESSAGE: 'I tuoi cantieri recenti appariranno qui una volta che inizierai a lavorarci.',

  // Time formatting
  TIME_JUST_NOW: 'Proprio ora',
  TIME_MINUTES_AGO: 'minuti fa',
  TIME_HOUR_AGO: '1 ora fa',
  TIME_HOURS_AGO: 'ore fa',
  TIME_YESTERDAY: 'Ieri',
  TIME_DAYS_AGO: 'giorni fa',
  TIME_WEEKS_AGO: 'settimane fa',

  // Project Status
  STATUS_ACCEPTED: 'Accettato',
  STATUS_REJECTED: 'Rifiutato',
  STATUS_PENDING: 'In Attesa',
  STATUS_COMPLETED: 'Completato',
  STATUS_IN_PROGRESS: 'In Corso',
  STATUS_CANCELLED: 'Annullato',
  DURATION_QUESTION: "Quanto tempo durerà l'installazione?",
  STATUS_QUESTION: "Qual è lo stato attuale dell'installazione?",
  TOOLS_REQUIRED_QUESTION: 'Quali strumenti sono necessari?',

  // Status Options (for select)
  STATUS_DELAYED: 'Ritardata',

  // Tool Options (for multiselect)
  TOOL_DRILL: 'Trapano',
  TOOL_LEVEL: 'Livella',
  TOOL_TAPE_MEASURE: 'Metro a Nastro',
  TOOL_SCREWDRIVER: 'Cacciavite',
  TOOL_CAULK_GUN: 'Pistola per Silicone',
  TOOL_SAFETY_GLASSES: 'Occhiali di Protezione',
  TOOL_WORK_GLOVES: 'Guanti da Lavoro',

  // New Labels
  PRODUCT_DOCUMENTS_TITLE: 'Documenti del Prodotto',
  PRODUCT_DOCUMENTS_DESCRIPTION: 'Documentazione relativa al prodotto.',
  SCHEDA_TECNICA_LABEL: 'Scheda Tecnica',
  DICHIARAZIONE_SOSTANZE_PERICOLOSE_LABEL: 'Dichiarazione Sostanze Pericolose',
  DICHIARAZIONE_DI_PRESTAZIONE_LABEL: 'Dichiarazione di Prestazione',

  CE_MARKING_TITLE: 'Marcatura CE',
  CE_MARKING_DESCRIPTION: 'Documentazione della marcatura CE.',
  MARCATURA_CE_LABEL: 'Marcatura CE',
  ETICHETTA_CE_LABEL: 'Etichetta CE',

  MAINTENANCE_DOCUMENTS_TITLE: 'Documenti di Manutenzione',
  MAINTENANCE_DOCUMENTS_DESCRIPTION: 'Documenti relativi alla manutenzione.',
  MANUALE_DI_MANUTENZIONE_LABEL: 'Manuale di Manutenzione',

  INSTALLATION_INFORMATION_TITLE: "Informazioni sull'Installazione",
  INSTALLATION_INFORMATION_DESCRIPTION: "Dettagli sull'installazione.",
  GIUNTO_SECONDARIO_FRONTALE_ALTO_SX_LABEL: 'Giunto Secondario Frontale Alto SX',
  GIUNTO_SECONDARIO_FRONTALE_BASSO_SX_LABEL: 'Giunto Secondario Frontale Basso SX',
  GIUNTO_SECONDARIO_FRONTALE_ALTO_DX_LABEL: 'Giunto Secondario Frontale Alto DX',
  GIUNTO_SECONDARIO_FRONTALE_BASSO_DX_LABEL: 'Giunto Secondario Frontale Basso DX',
  GIUNTO_SECONDARIO_FRONTALE_GENERALE_LABEL: 'Giunto Secondario Frontale Generale',
  GIUNTO_SECONDARIO_LATERALE_ALTO_SX_LABEL: 'Giunto Secondario Laterale Alto SX',
  GIUNTO_SECONDARIO_LATERALE_BASSO_SX_LABEL: 'Giunto Secondario Laterale Basso SX',
  GIUNTO_SECONDARIO_LATERALE_ALTO_DX_LABEL: 'Giunto Secondario Laterale Alto DX',
  GIUNTO_SECONDARIO_LATERALE_BASSO_DX_LABEL: 'Giunto Secondario Laterale Basso DX',
  GIUNTO_SECONDARIO_LATERALE_GENERALE_LABEL: 'Giunto Secondario Laterale Generale',

  INSTALLATION_INFORMATION_WIZARD_TITLE: 'Procedura Guidata Informazioni Installazione',
  INSTALLATION_INFORMATION_WIZARD_DESCRIPTION: "Processo guidato per raccogliere informazioni sull'installazione.",
  GIUNTO_SECONDARIO_FRONTALE_ALTO_SX_QUESTION: 'Carica una foto del giunto secondario frontale alto sinistro.',
  GIUNTO_SECONDARIO_FRONTALE_BASSO_SX_QUESTION: 'Carica una foto del giunto secondario frontale basso sinistro.',
  GIUNTO_SECONDARIO_FRONTALE_ALTO_DX_QUESTION: 'Carica una foto del giunto secondario frontale alto destro.',
  GIUNTO_SECONDARIO_FRONTALE_BASSO_DX_QUESTION: 'Carica una foto del giunto secondario frontale basso destro.',
  GIUNTO_SECONDARIO_FRONTALE_GENERALE_QUESTION: 'Carica una foto generale del giunto secondario frontale.',
  GIUNTO_SECONDARIO_LATERALE_ALTO_SX_QUESTION: 'Carica una foto del giunto secondario laterale alto sinistro.',
  GIUNTO_SECONDARIO_LATERALE_BASSO_SX_QUESTION: 'Carica una foto del giunto secondario laterale basso sinistro.',
  GIUNTO_SECONDARIO_LATERALE_ALTO_DX_QUESTION: 'Carica una foto del giunto secondario laterale alto destro.',
  GIUNTO_SECONDARIO_LATERALE_BASSO_DX_QUESTION: 'Carica una foto del giunto secondario laterale basso destro.',
  GIUNTO_SECONDARIO_LATERALE_GENERALE_QUESTION: 'Carica una foto generale del giunto secondario laterale.',

  // My Projects (installer)
  MY_PROJECTS_TITLE: 'Le mie commesse',
  MY_PROJECTS_SUBTITLE: 'Seleziona la commessa su cui vuoi lavorare.',
  MY_PROJECTS_EMPTY: 'Non hai commesse assegnate al momento.',
  MY_PROJECTS_SEARCH_PLACEHOLDER: 'Cerca per numero, cliente o indirizzo',
  MY_PROJECTS_SEE_ALL: 'Vedi tutte',

  // Bottom Navigation
  BOTTOM_NAV_HOME: 'Home',
  BOTTOM_NAV_PRODUCT_HOME: 'Prodotto',
  BOTTOM_NAV_PROJECT: 'Commessa',
  BOTTOM_NAV_LOGOUT: 'Logout',
  BOTTOM_NAV_LOGIN: 'Login',

  // Wizard Page
  WIZARD_SAVING_ANSWERS: 'Salvataggio delle risposte...',
  WIZARD_LOADING: 'Caricamento della procedura guidata...',
  WIZARD_ANSWER_QUESTION: 'Rispondi alla domanda',
  WIZARD_YOUR_ANSWER: 'La tua risposta',
  WIZARD_ENTER_ANSWER: 'Inserisci la tua risposta',
  WIZARD_SELECT_OPTION: 'Seleziona un\'opzione',
  WIZARD_SELECT_OPTIONS: 'Seleziona opzioni',
  WIZARD_TAKE_PHOTO: 'Scatta Foto',
  WIZARD_CHOOSE_PHOTO: 'Scegli Foto',
  WIZARD_REMOVE: 'Rimuovi',
  WIZARD_TAKE_PHOTOS: 'Scatta Foto',
  WIZARD_CHOOSE_PHOTOS: 'Scegli Foto',
  WIZARD_PHOTOS_STAGED: 'foto in coda per il caricamento',
  WIZARD_CLEAR_ALL: 'Cancella Tutto',
  WIZARD_BACK: 'Indietro',
  WIZARD_NEXT: 'Avanti',
  WIZARD_COMPLETE: 'Completa',
  WIZARD_SELECT_WIZARD: 'Seleziona una procedura guidata',

  // Language Switcher
  LANGUAGE: 'Lingua',
  ENGLISH: 'Inglese',
  ITALIAN: 'Italiano',

  // Loading Messages
  LOADING_INITIALIZING: 'Inizializzazione...',
  LOADING_REDIRECTING: 'Reindirizzamento alla dashboard di mock...',
  LOADING_DASHBOARD: 'Caricamento dashboard...',
  LOADING_PROJECT_DASHBOARD: 'Caricamento dashboard commessa...',
  LOADING_COMPLETING_LOGIN: 'Completamento login...',
  LOADING_PAGE: 'Caricamento pagina...',
  LOADING_PROJECT_DATA: 'Caricamento dati commessa...',
  LOADING_INSTALLER_DATA: 'Caricamento dati installatore...',
  LOADING_FILE_INFO: 'Caricamento informazioni file...',

  // History Dashboard
  HISTORY_TITLE: 'Cronologia',
  HISTORY_RECENT_PROJECTS: 'Cantieri Recenti',
  HISTORY_RECENT_EQUIPMENT: 'Serramenti Recenti',
  HISTORY_NO_RECENT_PROJECTS: 'Nessuna commessa recente',
  HISTORY_NO_RECENT_EQUIPMENT: 'Nessun serramento recente',
  HISTORY_PROJECTS_APPEAR_HERE: 'I cantieri che visiti appariranno qui',
  HISTORY_EQUIPMENT_APPEAR_HERE: 'Gli equipaggiamenti che visualizzi appariranno qui',
  HISTORY_CLEAR_HISTORY: 'Cancella Cronologia',
  HISTORY_CLEAR_CONFIRM: 'Sei sicuro di voler cancellare la cronologia?',
  HISTORY_PROJECT_TYPE: 'Cantieri',
  HISTORY_EQUIPMENT_TYPE: 'Serramenti',
  HISTORY_UNTITLED_PROJECT: 'Cantieri Senza Titolo',
  HISTORY_EQUIPMENT_DEFAULT: 'Serramento',
  HISTORY_JUST_NOW: 'Proprio ora',
  HISTORY_MINUTES_AGO: 'minuti fa',
  HISTORY_HOUR_AGO: '1 ora fa',
  HISTORY_HOURS_AGO: 'ore fa',
  HISTORY_YESTERDAY: 'Ieri',
  HISTORY_DAYS_AGO: 'giorni fa',

  // QR Code Information Card
  QR_INFO_TITLE: 'Informazioni QR',
  QR_INFO_DESCRIPTION: 'Informazioni sul codice QR e serramento',
  QR_TAG_ID_LABEL: 'ID Tag',
  QR_SERRAMENTO_LABEL: 'Serramento',
  QR_ASSET_STATUS_LABEL: 'Stato Asset',
  QR_PROJECT_LABEL: 'Commessa',
  QR_POSITION_LABEL: 'Posizione',
  QR_ARTICLE_LABEL: 'Articolo',
  QR_NO_DATA: 'Nessuna informazione disponibile',
  QR_LOADING: 'Caricamento informazioni QR...',
  QR_STATUS_COMPLETED: 'Completato',
  QR_STATUS_EMPTY: 'Vuoto',
  QR_STATUS_INITIALIZED: 'Inizializzato',
  QR_STATUS_PROCESSING: 'In elaborazione',
  QR_STATUS_ABORTED: 'Interrotto',
  QR_STATUS_UNKNOWN: 'Sconosciuto',

  // Linking Page
  LINKING_PAGE_TITLE: 'Gestione Codici QR',
  LINKING_LOADING_DATA: 'Caricamento dati collegamento...',
  LINKING_PROJECT_NOT_FOUND: 'Commessa non trovato',
  LINKING_PROJECT_ID_REQUIRED: 'ID Commessa richiesto',
  LINKING_FAILED_TO_LOAD_DATA: 'Errore nel caricamento dei dati',

  // Position Selection (Updated terminology)
  LINKING_SELECT_POSITION: 'Seleziona Vano Finestra',
  LINKING_SELECTED: 'Selezionato',
  LINKING_PROJECT_POSITIONS: 'Vani Finestra del Commessa',
  LINKING_CHOOSE_POSITION: 'Scegli un vano finestra...',
  LINKING_FLOOR: 'Piano',
  LINKING_POSITION_DETAILS: 'Dettagli Vano Finestra',
  LINKING_POSITION_NUMBER: 'Vano Finestra',
  LINKING_SEQUENCE_NUMBER: 'Sequenza',
  LINKING_DESCRIPTION: 'Descrizione',
  LINKING_ASSET: 'Serramento',
  LINKING_DIMENSIONS: 'Dimensioni',
  LINKING_NOTES: 'Note',
  LINKING_MANAGE: 'Gestisci',
  
  // Additional terminology consistency updates (KAN-19)
  SITE_MANAGEMENT: 'Gestione Commessa',
  SITE_OVERVIEW: 'Panoramica Commessa',
  SITE_DETAILS: 'Dettagli Commessa',

  // QR Tag Selection
  LINKING_SELECT_QR_TAG: 'Seleziona QR Tag',
  LINKING_AVAILABLE_QR_TAGS: 'QR Tag Disponibili',
  LINKING_CHOOSE_QR_TAG: 'Scegli un QR tag...',
  LINKING_QR_TAG_DETAILS: 'Dettagli QR Tag',
  LINKING_SERIAL_NO: 'Numero di Serie',
  LINKING_STATUS: 'Stato',
  LINKING_SEQUENCE: 'Sequenza',
  LINKING_YEAR: 'Anno',
  LINKING_CLIENT_CODE: 'Codice Cliente',
  LINKING_ASSET_MODEL: 'Modello Serramento',

  // Actions  
  LINKING_LINK_QR_TAG_TO_POSITION: 'Collega QR Tag al Vano Finestra',
  LINKING_UNLINK_QR_TAG: 'Scollega QR Tag',

  // Error Messages
  LINKING_SELECT_BOTH_POSITION_AND_QR_TAG: 'Seleziona sia un vano finestra che un QR tag',
  LINKING_FAILED_TO_LINK_QR_TAG: 'Errore nel collegamento del QR tag',
  LINKING_FAILED_TO_UNLINK_QR_TAG: 'Errore nello scollegamento del QR tag',

  // Success Messages
  LINKING_QR_TAG_LINKED_SUCCESS: 'QR tag collegato al vano finestra con successo!',
  LINKING_QR_TAG_UNLINKED_SUCCESS: 'QR tag scollegato dal vano finestra con successo!',

  // Linked QR Tags Section
  LINKING_POSITIONS_WITH_LINKED_QR_TAGS: 'Vani finestra con QR Tag Collegati',
  LINKING_LINKED_QR_TAG: 'QR Tag Collegato',
  LINKING_NO_LINKED_QR_TAG: 'QR Tag non collegato',
  HEADER_BACK: 'Indietro',

  // QR Code Management Page - Client Information
  QR_MANAGEMENT_COMMITTENTE_LABEL: 'Committente:',
  QR_MANAGEMENT_CLIENTE_FINALE_LABEL: 'Cliente Finale:',
  QR_MANAGEMENT_NO_COMMITTENTE: 'Non specificato',
  QR_MANAGEMENT_NO_CLIENTE_FINALE: 'Non specificato',
  
  // Updated terminology - Vano finestra instead of Posizione
  LINKING_SELECT_WINDOW_ROOM: 'Seleziona Vano Finestra',
  LINKING_PROJECT_WINDOW_ROOMS: 'Vani Finestra del Commessa',
  LINKING_CHOOSE_WINDOW_ROOM: 'Scegli un vano finestra...',
  LINKING_WINDOW_ROOM_DETAILS: 'Dettagli Vano Finestra',
  LINKING_WINDOW_ROOM_NUMBER: 'Vano Finestra',
  LINKING_WINDOW_ROOMS_WITH_LINKED_QR_TAGS: 'Vani Finestra con QR Tag Collegati',

  
  "PRODUCT_DETAIL_TITLE": "Dettagli Prodotto",
  "PRODUCT_DETAIL_DESCRIPTION": "Informazioni generali riguardo al prodotto.",
  "BRAND_LABEL": "Marca",
  "MODEL_LABEL": "Modello",
  "MODEL_DESCRIPTION_LABEL": "Descrizione Modello",
  "DESCRIPTION_LABEL": "Descrizione",
  "NOTES_LABEL": "Note",

  "DOCUMENT_DETAIL_TITLE": "Documenti Prodotto",
  "DOCUMENT_DETAIL_DESCRIPTION": "Tutti i documenti relativi al prodotto.",
  "TECHNICAL_SHEET_LABEL": "Scheda Tecnica del Modello",
  "INSTRUCTION_MANUAL_LABEL": "Manuale Uso e Manutenzione",
  "PRODUCT_PICTURE_LABEL": "Foto del Serramento",
  "INSTALLATION_DOCUMENT_LABEL": "Tavola di Posa",
  "CONSTRUCTION_SITE_PLAN_LABEL": "Planimetria del Cantiere",
  "CE_CERTIFICATION_LABEL": "Certificazione CE",
  "DOP_LABEL": "Dichiarazione di Prestazione (DOP)",
  "HAZARDOUS_SUBSTANCES_DECLARATION_LABEL": "Dichiarazione Sostanze Pericolose",

  "POSITION_INFO_TITLE": "Informazioni Vano Finestra",
  "POSITION_INFO_DESCRIPTION": "Dettagli sul vano finestra di installazione del prodotto.",
  "POSITION_NUMBER_LABEL": "Numero Vano Finestra",
  "POSITION_SEQUENCE_LABEL": "Sequenza Vano Finestra",
  "FLOOR_LABEL": "Piano",
  "WIDTH_LABEL": "Larghezza (mm)",
  "HEIGHT_LABEL": "Altezza (mm)",

  "PROJECT_INFO_TITLE": "Informazioni Commessa",
  "PROJECT_INFO_DESCRIPTION": "Dettagli sul commessa generale.",
  "PROJECT_NUMBER_LABEL": "Numero Commessa",
  "PROJECT_DATE_LABEL": "Data Commessa",
  "INSTALLER_INFO_LABEL": "Nome Installatore",

  "INSTALLATION_GALLERY_TITLE": "Galleria Installazione",
  "INSTALLATION_GALLERY_DESCRIPTION": "Foto scattate durante il processo di installazione.",
  "INSTALLATION_PHOTO_1_LABEL": "Foto Installazione 1",
  "INSTALLATION_PHOTO_2_LABEL": "Foto Installazione 2",
  "INSTALLATION_PHOTO_3_LABEL": "Foto Installazione 3",
  "INSTALLATION_PHOTO_4_LABEL": "Foto Installazione 4",
  "INSTALLATION_PHOTO_5_LABEL": "Foto Installazione 5",
  "INSTALLATION_PHOTO_6_LABEL": "Foto Installazione 6",
  "INSTALLATION_PHOTO_7_LABEL": "Foto Installazione 7",
  "INSTALLATION_PHOTO_8_LABEL": "Foto Installazione 8",
  

  "INSTALLATION_WIZARD_TITLE": "Avvia Acquisizione Immagini",
  "INSTALLATION_WIZARD_DESCRIPTION": "Scatta 4 foto del processo di installazione.",
  "INSTALLATION_PHOTO_1_QUESTION": "Scatta la prima foto dell'installazione.",
  "INSTALLATION_PHOTO_2_QUESTION": "Scatta la seconda foto dell'installazione.",
  "INSTALLATION_PHOTO_3_QUESTION": "Scatta la terza foto dell'installazione.",
  "INSTALLATION_PHOTO_4_QUESTION": "Scatta la foto finale dell'installazione.",
  "INSTALLATION_PHOTO_5_QUESTION": "Scatta la foto finale dell'installazione.",
  "INSTALLATION_PHOTO_6_QUESTION": "Scatta la foto finale dell'installazione.",
  "INSTALLATION_PHOTO_7_QUESTION": "Scatta la foto finale dell'installazione.",
  "INSTALLATION_PHOTO_8_QUESTION": "Scatta la foto finale dell'installazione.",

  // Project Dashboard
  "MANAGE_LINKINGS_TITLE": "Gestisci Collegamenti",
  "MANAGE_LINKINGS_DESCRIPTION": "Configura assegnazioni e connessioni delle attrezzature",

  "PROJECT_DASHBOARD_TITLE": "Commessa",
  "PROJECT_DASHBOARD_DESCRIPTION": "Gestisci tutte le posizioni e le attrezzature associate al commessa.",
  "NO_FILE_UPLOADED": "Documento non disponibile",
  "NETWORK_REQUEST_FAILED": "Connessione non riuscita. Verifica la rete e riprova.",
  "WIZARD_UPLOAD_FAILED": "Caricamento della foto non riuscito. Riprova.",
  "UPLOADING": "Caricamento...",
  "UPLOAD_IMAGE": "Carica Immagine",
  "UPLOAD_DOCUMENT": "Carica Documento",
  "UPLOAD_FILE": "Carica File",
  "PLEASE_UPLOAD_PDF_FILE": "Carica un file PDF",

  // Empty QR Tag
  "QR_TAG_EMPTY_TITLE": "Il QR Tag è Vuoto",
  "QR_TAG_EMPTY_DESCRIPTION": "Questo QR tag non ha ancora dati associati.",
  "QR_TAG_EMPTY_INSTALLER_DESCRIPTION": "Questo QR tag non ha ancora dati associati. Vuoi collegarlo a una posizione?",
  "LINK_TO_POSITION_BUTTON": "Collega al Vano Finestra",
  "PROJECT_INFO": "Commessa:",

  
  // Customer information fields
  CUSTOMER_NAME_LABEL: 'Nome Cliente',
  BUSINESS_NAME_LABEL: 'Ragione Sociale',
  CONTRACTOR_LABEL: 'Committente',
  END_CUSTOMER_LABEL: 'Cliente Finale',
  SITE_ADDRESS_LABEL: 'Commessa:',

  // Future customer fields (placeholders)
  COMMITTENTE_INFO: 'Informazioni Committente',
  CLIENTE_FINALE_INFO: 'Informazioni Cliente Finale',

  // Project Dashboard - Window Frame Elements (Updated for KAN-19)
  WINDOW_FRAME_ELEMENTS_TITLE: 'Elementi vano finestra',
  NO_ELEMENTS_ASSIGNED: 'Nessun elemento vano finestra assegnato',
  NO_ELEMENTS_ASSIGNED_DESCRIPTION: 'Questa commessa non ha elementi vano finestra assegnati.',
  
  // Context-specific element terminology (KAN-19)
  ELEMENTS_CONTEXT_WINDOW: 'Elementi vano finestra',
  ELEMENTS_CONTEXT_GENERAL: 'Elementi',

  // Element Card Labels
  QR_TAG_SERIAL_LABEL: 'Matricola QR Tag:',
  WINDOW_ROOM_IDENTIFIER: 'vano finestra',
  SERRAMENTO_TYPE_FALLBACK: 'Serramento',
  
  // Window Frame Element Identifiers (KAN-19)
  WINDOW_FRAME_ELEMENT_IDENTIFIER: 'Serramento vano finestra {{number}}',
  WINDOW_FRAME_ELEMENT_SHORT: 'Serramento vano finestra',
  
  // Construction Site Address Prefix (KAN-19)
  CONSTRUCTION_SITE_PREFIX: 'Commessa:',
  
  // Additional Client Information (KAN-19)
  CLIENT_INFORMATION_TITLE: 'Informazioni Cliente',
  CONTRACTOR_INFORMATION_TITLE: 'Informazioni Committente',
  END_CUSTOMER_INFORMATION_TITLE: 'Informazioni Cliente Finale',
  
  // QR Tag Information (KAN-19)
  QR_TAG_INFO_TITLE: 'Informazioni QR Tag',
  QR_TAG_SERIAL_NUMBER: 'Matricola QR Tag: {{serialNumber}}',
  
  // Element Status and Management (KAN-19)
  ELEMENT_STATUS_ASSIGNED: 'Assegnato',
  ELEMENT_STATUS_UNASSIGNED: 'Non assegnato',
  ELEMENT_MANAGEMENT_TITLE: 'Gestione Elementi',
  
  // Enhanced Window Room Terminology (KAN-19)
  WINDOW_ROOM_OPENING: 'Vano finestra',
  WINDOW_ROOM_ELEMENTS: 'Elementi vano finestra',
  WINDOW_ROOM_NUMBER_FORMAT: 'Vano finestra {{number}}',

  // Seller Information Labels
  SELLER_INFO_TITLE: 'Informazioni Venditore',
  SELLER_INFO_DESCRIPTION: 'Dettagli sul venditore del prodotto',
  ADDRESS_LABEL: 'Indirizzo',
  SUPPORT_PHONE_LABEL: 'Telefono Assistenza',
  SUPPORT_EMAIL_LABEL: 'Email Assistenza',
  WEBSITE_LABEL: 'Sito Web',

  // Position description label
  POSITION_DESCRIPTION_SHORT_LABEL: 'Descrizione Vano',
}
